import { InitialDataLoaderContext } from 'pages/MainLayout/InitialDataLoaderContext'
import React from 'react'

export const useIsInitialDataLoaded = () => {
  const { isDataLoaded } = React.useContext(InitialDataLoaderContext)

  return isDataLoaded
}
